// extracted by mini-css-extract-plugin
export default {"AppCustomers":"AppCustomers_AppCustomers__WPBTW","AppCustomers__wrap":"AppCustomers_AppCustomers__wrap__-CBYC"};